import secondLevelDomain from "./secondLevelDomain";

function isEmailOfDomain(email, domain) {
  const secondLvlDomain = secondLevelDomain(domain)
  if (!secondLevelDomain) {
    console.error("invalid domain");
    return false;
  }

  // parse email domain
  const tokens = email.split('@')
  if (tokens.length !== 2) {
    console.error("invalid email");
    return false;
  }

  const emailSecondLvlDomain = secondLevelDomain(tokens[1])
  if (!emailSecondLvlDomain) {
    console.error("invalid domain of email");
    return false;
  }

  if (secondLvlDomain !== emailSecondLvlDomain) {
    console.error("email is not from this domain");
    return false;
  }

  return true;
}

export default isEmailOfDomain;